import React from 'react';
import './index.css';

export default function Error404() {
    return (
        <div className = 'Error404'>
           <p className = 'error'> Error 404</p>
        </div>
    )
}